import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        popper: {
            zIndex: 9999,
        },
        container: {
            overflowY: 'auto',

            padding: theme.spacing(1.5, 1),
            width: 'max-content',
            maxWidth: '100vw',
            maxHeight: '100vh',

            backgroundColor: theme.customKeyboard.background,
        },
    };
});
